import { styled } from '@zoopla-eng/zds-components/themes';

export const NewHomesBodyBold = styled('p', {
    fontGroup: 'ladle',
    color: '$textTitle',
    fontWeight: '$regular'
});
